<template>
  <v-container id="login">
    <v-row justify="center">
      <v-col sm="12" md="8" lg="6">
        <MaterialCard
          :title="teaserTitle"
          color="primary"
          elevation="0"
          min-height="410"
        >
          <v-row align="center" justify="center">
            <v-col cols="12" sm="">
              <div
                class="body-1"
                v-html="$store.state.config.template_settings.login_teaser"
              ></div>
            </v-col>
          </v-row>
          <LoginForm></LoginForm>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";
import LoginForm from "./components/LoginForm";

export default {
  name: "Login",
  components: { LoginForm, MaterialCard },

  computed: {
    teaserTitle() {
      return (
        this.$store.state.config.template_settings.organization_display_name ||
        this.$store.state.config.name
      );
    }
  }
};
</script>
